import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslationService } from '../translations';

@Component({
    selector: 'pi-toggle',
    template: `
        @if (createToggle && !readOnly) {
            <div
                class="piToggle"
                [ngClass]="{
                    'piToggle-on': myValue,
                    'piToggle-disabled': disabled
                }"
                (click)="toggle($event)"
            >
                <div class="piToggle_toggleArea">
                    <div class="piToggle_toggleArea_ball"></div>
                </div>
                @if (labelKey) {
                    <div class="piToggle_label">
                        {{ TR.key(labelKey) }}
                    </div>
                }
            </div>
        }
        @if (readOnly) {
            <span>
                {{
                    myValue
                        ? TR.key('common.enabled')
                        : TR.key('common.disabled')
                }}
            </span>
        }
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ToggleComponent,
            multi: true
        }
    ],
    standalone: false
})
export class ToggleComponent implements ControlValueAccessor {
    @Input()
    labelKey = '';
    @Input()
    disabled = false;
    @Input()
    readOnly = false;

    createToggle = false;

    private _myValue: boolean;

    constructor(public TR: TranslationService) {}

    get myValue() {
        return this._myValue;
    }

    set myValue(val) {
        this.createToggle = typeof val === 'boolean';
        this._myValue = val;
        this.propagateChange(this._myValue);
    }

    propagateChange = (_: any) => {
        /* No change propagated */
    };

    toggle($event: Event) {
        if (!this.disabled) {
            this.myValue = !this.myValue;
        } else {
            $event.stopImmediatePropagation();
        }
    }

    writeValue(value: boolean): void {
        this.myValue = value;
    }
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }
    registerOnTouched(): void {
        /* No callback function registered OnTouched */
    }
    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }
}
